'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.some');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pseudoMap = ['hover', 'focus', 'active', 'visited']; /**
                                                          * just for legao
                                                          * @author: jiushen
                                                          */
// 需要通过 Env 来判断是否需要

var RE_CAMEL = /[A-Z]/g;
var RE_HYPHEN = /[-\s]+(.)?/g;
var CSS_REG = /:root(.*)\{.*/i;
var PROPS_REG = /([^:]*):\s?(.*)/i;

function isString(str) {
  return {}.toString.call(str) === '[object String]';
}

function hyphenate(str) {
  return str.replace(RE_CAMEL, function (w) {
    return '-' + w;
  }).toLowerCase();
}

function camelize(str) {
  return str.replace(RE_HYPHEN, function (m, w) {
    return w ? w.toUpperCase() : '';
  });
}
/**
 * convert
 * {background-color: "red"}
 * to
 * background-color: red;
 */
function runtimeToCss(runtime) {
  var css = [];
  Object.keys(runtime).forEach(function (key) {
    css.push('  ' + key + ': ' + runtime[key] + ';');
  });
  return css.join('\n');
}

function toNativeStyle(runtime) {
  if (!runtime) {
    return {};
  }
  if (runtime.default) {
    var _normalized = {};
    Object.keys(runtime).forEach(function (pseudo) {
      _normalized[pseudo] = toNativeStyle(runtime[pseudo]);
    });
    return _normalized;
  }

  var normalized = {};
  Object.keys(runtime).forEach(function (key) {
    normalized[camelize(key)] = runtime[key];
  });
  return normalized;
}

function normalizeStyle(style) {
  if (!style) {
    return {};
  }
  if (style.default) {
    var _normalized2 = {};
    Object.keys(style).forEach(function (pseudo) {
      _normalized2[pseudo] = normalizeStyle(style[pseudo]);
    });
    return _normalized2;
  }

  var normalized = {};
  Object.keys(style).forEach(function (key) {
    normalized[hyphenate(key)] = style[key];
  });
  return normalized;
}

function toCss(runtime) {
  if (!runtime) {
    return ':root {\n\n}';
  }

  if (runtime.default) {
    var css = [];
    Object.keys(runtime).forEach(function (pseudo) {
      // 只需要对这四种做兼容
      var prefix = pseudoMap.indexOf(pseudo) > -1 ? ':' : '';
      css.push(':root' + (pseudo === 'default' ? '' : '' + prefix + pseudo) + ' {\n' + runtimeToCss(normalizeStyle(runtime[pseudo])) + '\n}\n');
    });
    return css.join('\n');
  }

  return ':root {\n' + runtimeToCss(normalizeStyle(runtime)) + '\n}\n';
}

function cssToRuntime(css) {
  if (!css) {
    return {};
  }
  var runtime = {};

  if (CSS_REG.test(css)) {
    var cssArr = css.trim().replace(/[\r\n]+/ig, '').split('}');
    cssArr.forEach(function (rule) {
      var res = /:root:?(.*)?{(.*)/ig.exec(rule.trim());
      if (res) {
        var pseudo = void 0;

        if (res[1] && res[1].trim() && (0, _lodash2.default)(pseudoMap, function (pse) {
          return res[1].indexOf(pse) === 0;
        })) {
          pseudo = res[1].trim();
        } else if (res[1] && res[1].trim()) {
          pseudo = res[1];
        }

        var s = {};
        res[2].split(';').forEach(function (item) {
          if (item) {
            if (PROPS_REG.test(item)) {
              var props = item.match(PROPS_REG);
              var key = props[1];
              var value = props[2];
              if (key && value) {
                s[key.trim()] = value.trim();
              }
            }
          }
        });

        if (!pseudo) {
          pseudo = 'default';
        }
        runtime[pseudo] = s;
      }
    });
  }
  return runtime;
}

function cssToStyle(css) {
  try {
    if (isString(css)) {
      return toNativeStyle(cssToRuntime(css).default);
    }
    if (css.default) {
      return toNativeStyle(normalizeStyle(css.default));
    }
    return toNativeStyle(normalizeStyle(css));
  } catch (e) {}
  return {};
}

exports.default = {
  hyphenate: hyphenate,
  camelize: camelize,
  toNativeStyle: toNativeStyle,
  normalizeStyle: normalizeStyle,
  toCss: toCss,
  cssToRuntime: cssToRuntime,
  cssToStyle: cssToStyle
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_vu-css-style@1.1.1@@ali/vu-css-style/build/index.js
// module id = 74
// module chunks = 0